import PhoneFilterInput from './PhoneFilterInput'
import NumberFilterInput from './NumberFilterInput'
import TextFilterInput from './TextFilterInput'
import MultiSelectFilterInput from './MultiSelectFilterInput'
import PriceFilterInput from './PriceFilterInput'
import ImageFilterInput from './ImageFilterInput'
import SwitchFilterInput from './SwitchFilterInput'
import MapFilterInput from './MapFilterInput'
import MapFilterInputLeaflet from './MapFilterInputLeaflet'

import DateFilterInput from './DateFilterInput'
import FromToInput from './FromToInput'
import SelectListInput from './SelectListInput'
import IdFilterInput from './IdFilterInput'


const inputComponents = {
    PhoneInput: PhoneFilterInput,
    NumberInput: NumberFilterInput,
    TextInput: TextFilterInput,
    SelectInput: MultiSelectFilterInput,
    TextAreaInput: TextFilterInput,
    PriceInput: PriceFilterInput,
    AdvancedSelectInput: MultiSelectFilterInput,
    MultiSelectInput: MultiSelectFilterInput,
    MultiTreeSelectAddListing: MultiSelectFilterInput,
    // ImageInput:ImageFilterInput,
    SwitchInput: SwitchFilterInput,
    BooleanInput: SwitchFilterInput,
    MapFilterInput: MapFilterInputLeaflet,
    FromToInput: FromToInput,
    // DateInput: DateFilterInput,
    SelectListInput: SelectListInput,
    MultiLevelInput:MultiSelectFilterInput,
    IdInput:IdFilterInput
}

export default (inputComponents);